<template>
  <div>
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-6">
          <h6 class="mb-0">Журнал логов</h6>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-2">
          <label>Вид действия</label>
          <select class="form-control" v-model="conditions.event">
            <option value="">Все</option>
            <option v-for="o in events" :value="o.id">{{ o.title }}</option>
          </select>
        </div>
        <div class="col-md-2">
          <label>Объект действия</label>
          <select class="form-control" v-model="conditions.subject_type">
            <option value="">Все</option>
            <option v-for="o in subjectTypes" :value="o.id">{{ o.title }}</option>
          </select>
        </div>
        <div class="col-md-2">
          <label>Id объекта действия</label>
          <input type="text" class="form-control" v-model="conditions.subject_id"/>
        </div>
        <div class="col-md-3">
          <label>Id пользователя, совершившего действие</label>
          <input type="text" class="form-control" v-model="conditions.causer_id"/>
        </div>
        <div class="col-md-3">
          <label>День</label>
          <input type="date" class="form-control" v-model="conditions.day"/>
        </div>
        <div class="col-md-12 mt-3 text-end">
          <button class="btn btn-outline-info btn-themed btn-close-white px-5" @click="reset">Сброс</button>
          <button class="btn btn-info btn-themed px-5 ms-2" @click="search">Поиск</button>
        </div>
      </div>
      <div class="card overflow-wrapper mt-4" style="border-radius: 0">

        <vue-good-table
            mode="remote"
            @on-page-change="onPageChange"
            :columns="columns"
            :rows="logs"
            :totalRows="totalRecords"
            :sort-options="{ enabled: false }"
            :pagination-options="paginationOptions"
            styleClass="vgt-table condensed spacetable"
            compactMode
        >
          <template #table-row="props">
            <span v-if="props.column.field === 'created_at'">{{ props.formattedRow.created_at | formatDate('DD.MM.YYYY, HH:mm:ss') }}</span>
            <LongDatatableCell v-else-if="props.column.field === 'properties_old'" :content="props.row.properties.old"/>
            <LongDatatableCell v-else-if="props.column.field === 'properties_new'" :content="props.row.properties.attributes"/>
            <span v-else-if="props.column.field === 'subject_type'">{{ findSubjectType(props.formattedRow.subject_type) }}</span>
            <span v-else-if="props.column.field === 'event'">{{ findEventType(props.formattedRow.event) }}</span>
            <span v-else>{{ props.formattedRow[props.column.field] }}</span>
          </template>
        </vue-good-table>

        <table class="table table-striped admin-table mb-0">
          <thead>

          </thead>
        </table>
      </div>
    </div>
    <!--    {{ logs }}-->
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
import LongDatatableCell from "../components/LongDatatableCell.vue"

export default {
  name: "Logs",
  components: {
    LongDatatableCell,
    VueGoodTable,
  },
  data() {
    return {
      logs: [],
      page: 1,
      totalRecords: 0,
      loading: false,
      paginationOptions: {
        enabled: true,
        perPage: 20,
        perPageDropdownEnabled: false,
        mode: 'pages',
        firstLabel : 'Перв',
        lastLabel : 'Посл',
        nextLabel: '',
        prevLabel: '',
        pageLabel: 'стр',
        allLabel: 'Все',
      },
      subjectTypes: [
        { id: 'App\\Models\\Specific\\Ticket', title: 'Билет' },
        { id: 'App\\Models\\Specific\\City', title: 'Город' },
        { id: 'App\\Models\\Specific\\Order', title: 'Заказ' },
        { id: 'App\\Models\\Specific\\RefundApplication', title: 'Заявка на возврат' },
        { id: 'App\\Models\\General\\User', title: 'Пользователь' },
        { id: 'App\\Models\\Specific\\Promocode', title: 'Промокод' },
        { id: 'App\\Models\\Specific\\Timetable', title: 'Сеанс' },
        { id: 'App\\Models\\Specific\\Show', title: 'Событие' },
        { id: 'App\\Models\\Specific\\Pricegroup', title: 'Ценовая категория' },
      ],
      events: [
        { id: 'created', title: 'Создание' },
        { id: 'updated', title: 'Изменение' },
        { id: 'deleted', title: 'Удаление' },
        { id: 'admin_panel_opened', title: 'Вход в админ панель' },
        { id: 'admin_panel_closed', title: 'Выход из админ панели' },
      ],
      columns: [
        // {
        //   label: "ID",
        //   field: "id",
        // },
        {
          label: "Дата",
          field: "created_at",
        },
        {
          label: "Действие",
          field: "event",
        },
        {
          label: "Тип объекта",
          field: "subject_type",
        },
        {
          label: "Id объекта",
          field: "subject_id",
        },
        {
          label: "Id пользователя",
          field: "causer_id",
        },
        {
          label: "Имя пользователя",
          field: "causer_name",
        },
        {
          label: "Данные до",
          field: "properties_old",
        },
        {
          label: "Данные после",
          field: "properties_new",
        },
        {
          label: "Тип платежа",
          field: "pay_method",
        },
        {
          label: "IP",
          field: "ip",
        },
      ],
      conditions: {
        subject_type: null,
        subject_id: '',
        causer_id: '',
        event: null,
        day: ''
      }
    }
  },
  methods: {
    load() {
      window.loaderIcon(true)
      axios.get('/logs',{
        params: { page: this.page, conditions: this.conditions }
      }).then(res => {
        // console.log(res.data)
        this.totalRecords = res.data.total
        this.logs = res.data.data
      }).finally(() => window.loaderIcon(false))
    },
    onPageChange(params) {
      this.page = params.currentPage
      this.load()
    },
    findSubjectType(val) {
      const obj = this.subjectTypes.find(s => s.id === val)
      return obj?.title || val
    },
    findEventType(val) {
      const obj = this.events.find(s => s.id === val)
      return obj?.title || val
    },
    search() {
      this.page = 1
      this.load()
    },
    reset() {
      this.conditions = {
        subject_type: null,
        subject_id: '',
        causer_id: '',
        event: null,
        day: ''
      }
      this.page = 1
      this.load()
    }
  },
  mounted() {
    window.loaderIcon(false)
    this.load()
  }
}
</script>

<style scoped>
.spacetable {
  font-size: 14px;
}
</style>
